import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class OnBoardingDot extends Vue {
  @Prop() activeDotIdx = 0;
  
  get dotClasses(): string[] {
    const classes = (new Array(4)).fill('on-boarding-dot__dot');
    classes[this.activeDotIdx] = 'on-boarding-dot__dot on-boarding-dot__dot--active';
    return classes;
  }
}
